module.exports = __webpack_public_path__ + "media/images/emblems/Le_Cerneux-Pequignot-coat_of_arms-94cca4905dc25cc717fabd0bfdec1061.svg";